import React from "react";
import { FaDownload } from "react-icons/fa";
import Header from "./Components/Header";

export default function AppDownload() {
  return (
    <>
      <Header heading='App Download Instruction' />

    <div className=" bg-gray-100 flex justify-center px-4 py-2">
      <div className="max-w-xl w-full bg-white shadow-lg rounded-xl p-2 space-y-2">

        {/* Header */}
        <h1 className="text-2xl font-bold text-center text-gray-800">
          App Download Instructions
        </h1>
        <p className="text-center text-gray-600">
          Follow the steps below to download and install the IDSPay App on your device.
        </p>

        {/* Instructions */}
        <div className="space-y-4">
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
            <h2 className="font-semibold text-blue-800">Step 1: Download the App</h2>
            <p className="text-gray-700 text-sm">
              Click the button below to download the APK file to your Android device.
            </p>
          </div>

          <div className="bg-green-50 border-l-4 border-green-600 p-4 rounded">
            <h2 className="font-semibold text-green-800">Step 2: Allow “Unknown Sources”</h2>
            <p className="text-gray-700 text-sm">
              After downloading, go to Settings → Security → Enable "Install Unknown Apps".
            </p>
          </div>

          <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded">
            <h2 className="font-semibold text-yellow-800">Step 3: Install the App</h2>
            <p className="text-gray-700 text-sm">
              Open the downloaded APK file and follow instructions to complete installation.
            </p>
          </div>
        </div>

        {/* QR Code (optional) */}
        <div className="text-center">
          <p className="text-gray-700 font-medium mb-2">Scan QR to Download</p>
          <img
            src="/assets/images/download_qr.png"
            alt="QR Code"
            className="mx-auto w-40 h-40 rounded-md shadow"
          />
        </div>

        {/* Download Button */}
        <div className="text-center">
          <a
            href="/assets/images/IDSPay_API.apk"
            download="IDSPay_API.apk"
            className="inline-flex items-center bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-semibold gap-2 transition"
          >
            <FaDownload /> Download App
          </a>
        </div>

        {/* Footer Note */}
        <p className="text-center text-sm text-gray-500 mt-4">
          If the download doesn't start, make sure your browser allows downloads.
        </p>
      </div>
    </div>
        </>
  );
}
